import React, {Component} from 'react'
import { Table } from 'components/UI'
import {confirm} from 'util/confirm'
import { connect } from 'react-redux';
import __R, { userCan } from 'containers/__R'
import updateClassTeacher from 'controllers/teacher/updateClassTeacher'

import locale from '../locale'

const mapStateToProps = (state) => ({
  user: state.user,
})

class currentClassTable extends Component{
  constructor(props){
    super(props)

    this.state = {
      fetching: false,
    }
  }

  render(){
    const {showTable, teacherId, classList} = this.props

    const fields = [{
      name: 'ctClass__cName',
      title: __('Class', locale),
    }]

    const settings = [
      {
        title: __('Exit Class', locale),
        onClick: ({trData: teacher})=>{
          confirm(__('Proceed to exit teacher from class?', locale))
          .then(() => {
            updateClassTeacher(teacher.ctClass, teacherId, {state: 'archive'})
            .then((res) => {
              this.props.fetchTeacherInfo('current_class')
            })
            .catch((err) => {console.log(err)})
          })
          .catch(() => {})
        },
        isDisabled: ({trData: teacher})=>{
          return !userCan('archive_teacher_from_class')
        }
      },
    ]

    if(showTable){
      return(
        <Table
          data={classList}
          fields={fields}
          className='currentClassTable'
          settingThTitle={' '}
          settingWidth={'15%'}
          settings={settings}
          useMultiSelection={false}
          oneSettingPerRow={false}
          usePagination={false}
          hideDropdownCaret={true}
          fetching={this.state.fetching}
          dropdownGuideWidth={160}
          dropdownGuideHeight={228}
        />
      )
    } else {
      return(
        <div />
      )
    }
  }
}


export default connect(mapStateToProps)(currentClassTable)



// WEBPACK FOOTER //
// ./src/template/Docks/TeacherInfo/Tables/currentClassTable.js